<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="查看支出详情"
      width="500"
      :open="open"
      @close="close"
      class="detail-dialog"
    >
      <mu-list>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>操作人</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.user.realName }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>时间</mu-list-item-title>
          <mu-list-item-action>
            {{ moment(detail.createTime).format('YYYY-MM-DD HH:mm') }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>名称</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.name }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>单价</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.price }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>单位</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.unit }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>数量</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.count }}
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>总价</mu-list-item-title>
          <mu-list-item-action>
            {{ detail.sum }}
          </mu-list-item-action>
        </mu-list-item>
        <!-- <mu-list-item button :ripple="false">
          <mu-list-item-title>分类</mu-list-item-title>
          <mu-list-item-action>
            {{detail.name}}
          </mu-list-item-action>
        </mu-list-item> -->
        <mu-list-item button :ripple="false">
          <mu-list-item-title>音频</mu-list-item-title>
          <mu-list-item-action>
            <mu-button
              color="primary"
              @click="play(detail.record)"
              v-if="detail.record"
            >
              <mu-icon left value="record_voice_over"></mu-icon>
              播放
            </mu-button>
            <span v-else>无录音</span>
          </mu-list-item-action>
        </mu-list-item>
        <mu-list-item button :ripple="false">
          <mu-list-item-title>图片</mu-list-item-title>
          <mu-list-item-action>
            <mu-button
              color="secondary"
              @click="viewImages(detail.images)"
              v-if="detail.images.length > 0"
            >
              <mu-icon left value="image"></mu-icon>
              查看
            </mu-button>
            <span v-else>无图片</span>
          </mu-list-item-action>
        </mu-list-item>
      </mu-list>
    </mu-dialog>
    <ImageView :open.sync="imageOpen" :imageList="imageList"></ImageView>
    <audio
      :src="audio"
      ref="audio"
      class="audio"
      @canplay="canPlay"
      @ended="playEnd"
    ></audio>
  </div>
</template>

<script>
import moment from 'moment'
import ImageView from '@/components/imageView'
export default {
  components: { ImageView },
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    detail: {
      type: Object
    }
  },
  data() {
    return {
      moment,
      audio: '',
      imageList: [],
      imageOpen: false
    }
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    },
    play(record) {
      this.audio = record
    },
    canPlay() {
      this.$refs.audio.play()
    },
    playEnd() {
      this.audio = ''
    },
    viewImages(images) {
      this.imageList = images
      this.imageOpen = true
    }
  }
}
</script>

<style lang="less" scoped>
.detail-dialog {
}
.audio {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/outVerify/detail.vue